<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2251_184)">
<rect x="2.35" y="5.85" width="17.3" height="10.3" rx="1.15" stroke="currentColor" stroke-width="1.7"/>
<rect x="7.33792" y="10.3" width="7.32415" height="1.4" rx="0.7" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2251_184">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
